import { CabinetArrowRightIcon } from '@/components/Icons/CabinetArrowRightIcon.js';
import { styled } from '@/stitches/index.js';
import { type ReactNode } from 'react';

const LastWordWithArrow = styled('span', {
  display: 'inline-flex',
  whiteSpace: 'nowrap',
});

const StyledArrowWrapper = styled('p', {
  display: 'inline',
  position: 'relative',
});

const ArrowSpan = styled('span', {
  alignItems: 'center',
  display: 'inline-flex',
  marginLeft: '$8',
});

export const WrapWithArrow = ({
  customArrow,
  margin,
  text,
}: {
  readonly customArrow?: ReactNode;
  readonly margin?: Number;
  readonly text: string;
}) => {
  const words = text.trim().split(' ');
  let lastWord = words.pop() || '';

  // If the last 'word' is a single character, like an emoji, don't wrap it alone
  if (lastWord.length === 1 && words.length) {
    lastWord = `${words.pop()} ${lastWord}`;
  }

  return (
    <StyledArrowWrapper>
      {`${words.join(' ')} `}
      <LastWordWithArrow>
        <span>{`${lastWord}`}</span>
        <ArrowSpan
          css={{
            marginLeft: margin ? `$${margin}` : '$16',
          }}
        >
          {customArrow ? customArrow : <CabinetArrowRightIcon />}
        </ArrowSpan>
      </LastWordWithArrow>
    </StyledArrowWrapper>
  );
};
